import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';
import { IRoutePermissions } from '../../types/common';
import { dashboardAnalytics } from './types/dashboardAnalytics';
import { UserCapabilityName } from '../../types/userCapabilityName';

const Dashboard = lazy(
  () => import(/* webpackChunkName: "dashboard" */ './Dashboard')
);

export const dashboardRoutePerm: IRoutePermissions = {};
const { dashboard } = dashboardAnalytics;

export const dashboardRoutes = (
  <Route
    path="dashboard"
    element={
      <PageRoute
        pageInfo={dashboard}
        userCapabilities={[
          UserCapabilityName.SuperAdmin,
          UserCapabilityName.ViewReports,
        ]}
      >
        <Dashboard />
      </PageRoute>
    }
  />
);
